import { getLocalItem, getCookieItem } from "@/lib/commonService";
import { isLogin } from "@/src/models";
import personalizeEvents, {
    personalizeBatchEventLogin,
    personalizeEvent,
} from "@/src/models/personalize";
import { gaLoadedPromise } from "@/src/utils";
import { ClickstreamAnalytics } from "@aws/clickstream-web";

// 事件类型定义
type EventType =
    | "addWishlist"
    | "clickProduct"
    | "addCart"
    | "tryOn"
    | "createOrder"
    | "paidOrder";

const getUserType = (): string => {
    if (!isLogin()) {
        return "4";
    }
    const is_old_customer = getLocalItem("is_old_customer") || false;
    return is_old_customer ? "2" : "5";
};

class DataAcquisition {
    stadus: boolean = false;

    // 初始化参数
    initParams: { appId: string; endpoint: string } = {
        appId: "firmoo_clickstream_app",
        endpoint: "https://click-stream.firmooinc.com/collect",
    };

    init(): void {
        this.onLoad();
    }

    // 初始化
    onLoad(): void {
        try {
            this.stadus = false;
            const result = ClickstreamAnalytics.init(this.initParams);
            if (result) {
                const userid = getCookieItem("user_id") || null;
                ClickstreamAnalytics.setUserId(userid);
                ClickstreamAnalytics.setUserAttributes({
                    user_type: getUserType(),
                });

                // // pageView事件
                // setTimeout(() => {
                //   this.customEvent('page_view', {});
                // }, 0);
            }
            this.stadus = result;
        } catch (error) {
            console.error("Error occurred in onLoad:", error);
            this.stadus = false;
        }
    }

    // 登录
    login(name: string, id: string | number): void {
        try {
            if (this.stadus) {
                const userid = getCookieItem("user_id") || null;
                ClickstreamAnalytics.setUserId(userid);
                personalizeBatchEventLogin(
                    typeof id === "number" ? id : parseInt(id),
                );
            }
        } catch (error) {
            console.error("Error occurred in login:", error);
        }
    }

    // 退出登录
    OutLogin(): void {
        try {
            if (this.stadus) {
                const userid = getCookieItem("user_id") || null;
                ClickstreamAnalytics.setUserId(userid);
            }
        } catch (error) {
            console.error("Error occurred in OutLogin:", error);
        }
    }

    /**
     * 记录事件
     * @param name 事件类型
     * @param attributes 事件属性
     */
    record(name: EventType, id: string | string[]): void {
        try {
            // 主动埋点
            personalizeEvents.putEvent(name, Array.isArray(id) ? id[0] : id);
            if (this.stadus) {
                personalizeEvent(name, Array.isArray(id) ? id[0] : id);
                const itemId = Array.isArray(id) ? id.join(",") : id;
                ClickstreamAnalytics.record({
                    name: name,
                    attributes: { item_id: itemId },
                });
            }
        } catch (error) {
            console.error("Error occurred in record:", error);
        }
    }

    // 收藏
    addWishlist(name: string, id: string): void {
        this.record("addWishlist", id);
        gaLoadedPromise()
            .then(() => {
                window.gtag &&
                    window.gtag("event", "addWishlist", {
                        item_id: id,
                    });
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // 商品点击
    clickProduct(name: string, id: string): void {
        this.record("clickProduct", id);
    }

    // 添加购物车
    addCart(name: string, id: string): void {
        this.record("addCart", id);
    }

    // tryOn
    tryOn(name: string, id: string): void {
        this.record("tryOn", id);
    }

    // 创建订单
    createOrder(
        name: string,
        id: string | string[],
        orders_oid: string | number,
    ): void {
        const eventName: EventType = "createOrder";
        if (Array.isArray(id)) {
            id.forEach((item) => {
                personalizeEvents.putEvent(eventName, item);
            });
        } else {
            personalizeEvents.putEvent(eventName, id);
        }
        if (this.stadus) {
            personalizeEvent(eventName, Array.isArray(id) ? id[0] : id);
            const items = Array.isArray(id)
                ? id.map((item) => {
                      return {
                          id: item,
                      };
                  })
                : [{ id: id }];
            ClickstreamAnalytics.record({
                name: eventName,
                attributes: {
                    items: JSON.stringify(items),
                    orders_oid: orders_oid,
                },
            });
        }
    }

    // 支付成功
    paidOrder(name: string, id: string, orders_oid: string | number): void {
        const eventName: EventType = "paidOrder";
        // 主动埋点
        personalizeEvents.putEvent(eventName, id);
        if (this.stadus) {
            personalizeEvent(eventName, id);
            ClickstreamAnalytics.record({
                name: eventName,
                attributes: { item_id: id, orders_oid: orders_oid },
            });
        }
    }

    // 自定义事件，不向千人千面发起记录请求
    customEvent(name: string, attributes: Record<string, any>): void {
        try {
            if (this.stadus) {
                ClickstreamAnalytics.record({
                    name: name,
                    attributes: attributes,
                });
            }
        } catch (error) {
            console.error("Error occurred in customEvent:", name, error);
        }
    }
}

// ClickstreamAnalytics.record({
//   name: 'clickProduct_exposure',
//   attributes: {
//     // 商品id+色号id
//     item_id: '123-456',
//     // 商品索引（从上到下从左到右）
//     // 确定用户类型
//     // 已登录 + 已下单 2
//     // 未登录 4
//     // 已登录 + 未下单 5
//     user_type: '2'
//   }
// });

// ClickstreamAnalytics.record({
//   name: 'nav_click',
//   attributes: {
//     // 导航链接
//     nav_url: 'https://www.firmoo.com/z/eyeglasses-for-women.html',
//     // 导航级别
//     nav_level: 1,
//     // 导航索引（从上到下从左到右）
//     nav_index: 1,
//     // 确定用户类型
//     // 已登录 + 已下单 2
//     // 未登录 4
//     // 已登录 + 未下单 5
//     user_type: '2'
//   }
// });

// ClickstreamAnalytics.record({
//   name: 'ad_click',
//   attributes: {
//     // banner/bubble/combination等
//     ad_type: 'banner',
//     // 广告图片
//     ad_img: 'https://www.firmoo.com/images/ad/banner.jpg',
//     // 广告链接
//     ad_url: 'https://www.firmoo.com/z/eyeglasses-for-women.html',
//     // 导航索引（从上到下从左到右）
//     ad_index: 1,
//     // 确定用户类型
//     // 已登录 + 已下单 2
//     // 未登录 4
//     // 已登录 + 未下单 5
//     user_type: '2'
//   }
// });

const acquisition = new DataAcquisition();

export default acquisition;
